<template>
    <div class="condition-wrap">
        <ul class="codition-content">
            <li v-for="item in conditionData" :key="item.id" class="codition-item">
                <el-select
                    v-model="item.paramId"
                    style="width:40%"
                    :placeholder="$i18n.t('zhiji.portrait.selectHold')"
                    filterable
                    @change="changeData"
                >
                    <el-option v-for="child in paramOptions" :key="child.value" :label="child.label" :value="child.value" />
                </el-select>
                <el-select v-model="item.condition" style="width:20%" :placeholder="$i18n.t('zhiji.portrait.selectHold')" @change="changeData">
                    <el-option v-for="child in operateOptions" :key="child.value" :label="child.label" :value="child.value" />
                </el-select>
                <el-input v-model="item.value" style="width:40%" :placeholder="$i18n.t('zhiji.portrait.emptyHold')" @change="changeData" />
                <el-button icon="el-icon-delete" size="small" @click="deleteClick(item.id)" />
            </li>
        </ul>
        <el-button class="el-icon-plus" size="" @click="addClick" />
    </div>
</template>

<script>
import { uniqueId } from "@/views/zhiji/js/common/util.js";
const operateOptions = [
    {
        label: "=",
        value: "="
    },
    {
        label: "≠",
        value: "!="
    },
    {
        label: ">",
        value: ">"
    },
    {
        label: "≥",
        value: ">="
    },
    {
        label: "<",
        value: "<"
    },
    {
        label: "≤",
        value: "<="
    }
];

export default {
    name: "ConditionList",
    model: {
        prop: "modelVal",
        event: "update"
    },
    props: {
        modelVal: {
            type: Array,
            default() {
                return [];
            }
        },
        paramOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            operateOptions,
            conditionData: []
        };
    },
    watch: {
        modelVal(data) {
            this.conditionData = data.map(item => ({
                ...item,
                id: uniqueId(),
                paramId: item.param_id
            }));
        }
    },
    methods: {
        addClick() {
            this.conditionData.push({
                id: uniqueId(),
                paramId: "",
                condition: "",
                value: ""
            });
            this.changeData();
        },
        deleteClick(id) {
            this.conditionData = this.conditionData.filter(item => item.id !== id);
            this.changeData();
        },
        changeData() {
            this.$emit(
                "update",
                this.conditionData.map(item => ({
                    param_id: item.paramId,
                    condition: item.condition,
                    value: item.value
                }))
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.condition-wrap {
    .codition-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        .el-button {
            border: none;
        }
        >div{
            margin-right: 8px;
        }
    }
    .codition-content{
        padding-left: 0;
    }
    /deep/.el-icon-plus:before {
        font-size: 17px;
    }
}
</style>
